// Converts numeric degrees to radians
const toRad = (v: number) => (v * Math.PI) / 180;

export const calcCrowDistanceInMiles = (
    p1_lat: number,
    p1_lng: number,
    p2_lat: number,
    p2_lng: number
): number => {
    const R = 3960; // km
    const dLat = toRad(p2_lat - p1_lat);
    const dLon = toRad(p2_lng - p1_lng);
    const lat1 = toRad(p1_lat);
    const lat2 = toRad(p2_lat);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) *
            Math.sin(dLon / 2) *
            Math.cos(lat1) *
            Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};

export default calcCrowDistanceInMiles;
